<template>
    
</template>

<script>
    export default {
        name: "null",
      created(){
        this.$router.go(-1);
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/null.vue